import VueRouter from 'vue-router'

let routes = [
    {
      path: '/',
      component: require('./pages/Home').default,
      meta: {
        title: 'Homepage',
        metaTags: [
          {
            property: 'og:title',
            content: 'Homepage'
          },
          {
            name: 'twitter:title',
            content: 'Homepage'
          },
          {
            name: 'description',
            content: 'home desc'
          },
          {
            property: 'og:description',
            content: 'home desc'
          },
          {
            name: 'twitter:description',
            content: 'home desc'
          },
          {
            property: 'og:image',
            content: window.baseUrl + '/img/web_share.jpg'
          },
          {
            name: 'twitter:image',
            content: window.baseUrl + '/img/web_share.jpg'
          }
        ]
      }
    },
    {
      path: '/configurator',
      // name: 'configurator',
      component: require('./pages/Configurator').default,
      children: [
        {
          path: '',
          redirect: '/infos',
        },
        {
          path: '/infos',
          name: 'A',
          component: require('./pages/configurator/A').default,
          meta: {
            position: 1
          }
        },
        {
          path: '/content',
          name: 'B',
          component: require('./pages/configurator/B').default,
          meta: {
            position: 2
          }
        },
        {
          path: '/model',
          name: 'C',
          component: require('./pages/configurator/C').default,
          meta: {
            position: 3
          }
        },
        {
          path: '/look',
          name: 'D',
          component: require('./pages/configurator/D').default,
          meta: {
            position: 4
          }
        },
        {
          path: '/services',
          name: 'E',
          component: require('./pages/configurator/E').default,
          meta: {
            position: 5
          }
        },
        {
          path: '/payment',
          name: 'F',
          component: require('./pages/configurator/F').default,
          meta: {
            position: 6
          }
        },
        {
          path: '/congrats',
          name: 'Congrats',
          component: require('./pages/configurator/Congrats').default,
          meta: {
            position: 7
          }
        }
      ],
      meta: {
        title: 'Configurator',
        metaTags: [
          {
            property: 'og:title',
            content: 'Configurator'
          },
          {
            name: 'twitter:title',
            content: 'Configurator'
          },
          {
            name: 'description',
            content: 'configurator desc'
          },
          {
            property: 'og:description',
            content: 'configurator desc'
          },
          {
            name: 'twitter:description',
            content: 'configurator desc'
          },
          {
            property: 'og:image',
            content: window.baseUrl + '/img/web_share.jpg'
          },
          {
            name: 'twitter:image',
            content: window.baseUrl + '/img/web_share.jpg'
          }
        ]
      }
    },
    {
      path: '/dashboard',
      component: require('./pages/Dashboard').default,
      children: [
        {
          path: '',
          redirect: '/dashboard/contents',
        },
        {
          path: '/dashboard/homepage',
          name: 'Homepage',
          component: require('./pages/dashboard/Homepage').default,
          meta: {
            position: 1
          }
        },
        {
          path: '/dashboard/contents',
          name: 'Contents',
          component: require('./pages/dashboard/Contents').default,
          meta: {
            position: 2
          }
        },
        {
          path: '/dashboard/monetization',
          name: 'Monetization',
          component: require('./pages/dashboard/Monetization').default,
          meta: {
            position: 3
          }
        }
      ],
      meta: {
        title: 'Dashboard',
        metaTags: [
          {
            property: 'og:title',
            content: 'Dashboard'
          },
          {
            name: 'twitter:title',
            content: 'Dashboard'
          },
          {
            name: 'description',
            content: 'Dashboard desc'
          },
          {
            property: 'og:description',
            content: 'Dashboard desc'
          },
          {
            name: 'twitter:description',
            content: 'Dashboard desc'
          },
          {
            property: 'og:image',
            content: window.baseUrl + '/img/web_share.jpg'
          },
          {
            name: 'twitter:image',
            content: window.baseUrl + '/img/web_share.jpg'
          }
        ]
      }
    },
    {
      path: '/preview',
      component: require('./pages/Preview').default,
      children: [
        {
          path: '/preview',
          name: 'Home',
          component: require('./pages/preview/Home').default
        },
        {
          path: '/player',
          name: 'Player',
          component: require('./pages/preview/Player').default,
        }
      ],
      meta: {
        title: 'Preview',
        metaTags: [
          {
            property: 'og:title',
            content: 'Preview'
          },
          {
            name: 'twitter:title',
            content: 'Preview'
          },
          {
            name: 'description',
            content: 'preview desc'
          },
          {
            property: 'og:description',
            content: 'preview desc'
          },
          {
            name: 'twitter:description',
            content: 'preview desc'
          },
          {
            property: 'og:image',
            content: window.baseUrl + '/img/web_share.jpg'
          },
          {
            name: 'twitter:image',
            content: window.baseUrl + '/img/web_share.jpg'
          }
        ]
      }
    },
    {
      path: '*',
      redirect: '/'
    }
];

const router = new VueRouter({

    routes,
    mode: "history",
    linkExactActiveClass: 'current',
    linkActiveClass: 'current',

});

router.beforeEach((to, from, next) => {

  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // Remove All Meta Vue Managed
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // If No Meta To Change
  if(!nearestWithMeta) return next();

  // Loop Over Metas
  nearestWithMeta.meta.metaTags.map(tagDef => {

    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  .forEach(tag => document.head.appendChild(tag));

  const url = window.baseUrl + nearestWithTitle.path;

  let tag = document.createElement('meta');
  tag.setAttribute('property', 'og:url');
  tag.setAttribute('content', url);
  tag.setAttribute('data-vue-router-controlled', '');
  document.head.appendChild(tag)

  tag = document.createElement('meta');
  tag.setAttribute('name', 'twitter:url');
  tag.setAttribute('content', url);
  tag.setAttribute('data-vue-router-controlled', '');
  document.head.appendChild(tag)

  next();

});

export default router